document.addEventListener("DOMContentLoaded", ()=>{
    const button = document.querySelector(".pdp-checkout-button")
    const button_inner = document.querySelector(".checkout-button__inner")
    const loader = document.querySelector(".checkout-button__loader")
    const form = document.querySelector(".product-form-custom")

    if (form){
        button.addEventListener("click", async (event)=>{
            event.preventDefault()
            const formData = new FormData(form)
            button.style.justifyContent = "center"
            button_inner.style.display = "none"
            loader.style.display = "block"
            await fetch("/cart/add.js", {
                method: "POST",
                body: formData
            })
                .then(res=> res.json())
                .then(data => {
                    if (data){
                        button.style.justifyContent = "space-between"
                        button_inner.style.display = "inline-block"
                        loader.style.display = "none"
                        window.location.href = "/checkout"
                    }
            })
        })
    }
})